import React from 'react';
import styled from 'styled-components';

import {CalendarView} from '@ibibo/dcalendar';

import {addDays} from '../../../../../shared/utils/date-utils';
import {maxAllowedRoomNights, defaultLengthOfStay} from '../../../../../shared/config/app-config';

const CalendarBlock = React.forwardRef(
  (
    props: {
      isSearchWidget;
      isCheckinMode;
      isCheckoutMode;
      onSelection;
      updateQueryCaller;
      checkin;
      checkout;
    },
    ref,
  ) => {
    const {
      isSearchWidget,
      isCheckinMode,
      isCheckoutMode,
      onSelection,
      updateQueryCaller,
      checkin,
      checkout,
    } = props;

    const getClassName = (dateObj: Date, checkin?: Date, checkout?: Date) => {
      if (
        checkin &&
        dateObj.getMonth() === checkin.getMonth() &&
        dateObj.getDate() === checkin.getDate() &&
        dateObj.getFullYear() === checkin.getFullYear()
      ) {
        return 'leftactive';
      }
      if (
        checkout &&
        dateObj.getMonth() === checkout.getMonth() &&
        dateObj.getDate() === checkout.getDate() &&
        dateObj.getFullYear() === checkout.getFullYear()
      )
        return 'rightactive';
      if (
        checkin &&
        checkout &&
        dateObj.getTime() > checkin.getTime() &&
        dateObj.getTime() < checkout.getTime()
      )
        return 'partial';
      return '';
    };

    // const getClassName = (
    //   target: number,
    //   targetMonth: number,
    //   dateObj: Date,
    //   checkin?: Date,
    //   checkout?: Date,
    // ) => {
    //   if (checkin && targetMonth === checkin.getMonth() && target === checkin.getDate()) {
    //     return 'leftactive';
    //   }
    //   if (checkout && targetMonth === checkout.getMonth() && target === checkout.getDate())
    //     return 'rightactive';
    //   if (
    //     checkin &&
    //     checkout &&
    //     dateObj.getTime() > checkin.getTime() &&
    //     dateObj.getTime() < checkout.getTime()
    //   )
    //     return 'partial';
    //   return '';
    // };

    const dateOnClickHandler = dateObj => {
      if (isCheckinMode) {
        updateQueryCaller({
          checkin: {...checkin, date: dateObj},
          checkout: {...checkout, date: addDays(dateObj, defaultLengthOfStay)},
        });
        onSelection();
      } else {
        updateQueryCaller({
          checkout: {...checkout, date: dateObj},
        });
        onSelection();
      }
    };

    const todaysDate = new Date();

    const maxDateAllowed = new Date();
    maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);
    if (isCheckoutMode) {
      todaysDate.setDate(checkin.date.getDate() + 1);
      maxDateAllowed.setDate(maxDateAllowed.getDate() + maxAllowedRoomNights);
    }

    return (
      <CalendarBlockOuterWrapper ref={ref} isSearchWidget={isSearchWidget}>
        <CalendarView
          monthToBeDisplayed={isCheckinMode ? checkin.date.getMonth() : checkout.date.getMonth()}
          yearToBeDisplayed={isCheckinMode ? checkin.date.getFullYear() : checkout.date.getFullYear()}
          minDateAllowed={todaysDate}
          maxDateAllowed={maxDateAllowed}
          renderDateItem={({keyVal, value, dateObj}) => {
            if (!value) {
              return (
                <li key={keyVal}>
                  <span></span>
                </li>
              );
            }

            let isValid = true;

            dateObj.setHours(0, 0, 0, 0);

            if (isCheckinMode) {
              todaysDate.setHours(0, 0, 0, 0);
              isValid = dateObj >= todaysDate;
            }

            if (isCheckoutMode) {
              checkin.date.setHours(0, 0, 0, 0);
              const checkinLimit = addDays(checkin.date, 20);
              isValid = dateObj > checkin.date && dateObj < checkinLimit;
            }

            return (
              <li
                key={keyVal}
                style={isValid ? {color: 'black', cursor: 'pointer'} : {opacity: '0.4', color: 'grey', cursor: 'default'}}
                onClick={() => {
                  isValid ? dateOnClickHandler(dateObj) : () => {};
                }}
                // isValid={isValid}
              >
                <span className={getClassName(dateObj, checkin.date, checkout.date)}>{value}</span>
              </li>
            );
          }}
        />
      </CalendarBlockOuterWrapper>
    );
  },
);

export default CalendarBlock;

const CalendarBlockOuterWrapper = styled.div(
  // increase height here to display HolidayCalendar
  props => `
    width: 33.5rem;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: ${props.isSearchWidget ? '5.4rem' : '10.9rem'};
    // left: 44rem;
    z-index: ${props.theme.misc.zIndex.xlarge};
    border-radius: ${props.theme.misc.borderRadius.base};
  `,
);
